<div class="front-wrap">
	<div class="front-store-content">
		<div class="container">
			<div class="dash-head">
				<h2>Profile</h2>
			</div>
			<div class="prfl-stp-hz">
				<mat-horizontal-stepper [linear]="isLinear" #stepper>
					<mat-step [stepControl]="firstFormGroup">
						<ng-template matStepLabel>Personal Information</ng-template>
						<form [formGroup]="editEndUserProfileForm"
							(submit)="UpdateEndUserProfile(editEndUserProfileForm)">
							<div class="pro-st-wrp">
								<h4 class="prsnl-ttl">Personal Information</h4>
								<small *ngIf="forceChangePassword" class="blink_me text-danger">*Stoked On Printing is
									simplifying the process of login on it's all platform so you won’t have to create
									separate accounts. In order to fulfill this it is requested to change your password,
									thank you for your cooperation.</small>
								<div class="row">
									<div class="col-sm-6">
										<mat-form-field class="full-input">
											<input matInput placeholder="First name" formControlName="FirstName">
											<mat-error
												*ngIf="f.FirstName.touched && f.FirstName.invalid && f.FirstName.pristine">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.FirstName.valid && (!f.FirstName.hasError('pattern') && f.FirstName.touched && f.FirstName.dirty)">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.FirstName.valid && (f.FirstName.hasError('pattern') && f.FirstName.dirty)">
												Should contain only letters
											</mat-error>
										</mat-form-field>
									</div>

									<div class="col-sm-6">
										<mat-form-field class="full-input">
											<input matInput placeholder="Last Name" formControlName="LastName">
											<mat-error
												*ngIf="f.LastName.touched && f.LastName.invalid && f.LastName.pristine">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.LastName.valid && (!f.LastName.hasError('pattern') && f.LastName.touched && f.LastName.dirty)">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.LastName.valid && (f.LastName.hasError('pattern') && f.LastName.dirty)">
												Should contain only letters
											</mat-error>
										</mat-form-field>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-6">
										<mat-form-field class="full-input">
											<input matInput placeholder="Email" formControlName="Email" readonly>
											<mat-error *ngIf="f.Email.touched && f.Email.invalid && f.Email.pristine">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.Email.valid && (!f.Email.hasError('pattern') && f.Email.touched && f.Email.dirty)">
												<strong>Required</strong>
											</mat-error>
											<mat-error
												*ngIf="!f.Email.valid && (f.Email.hasError('pattern') && f.Email.dirty)">
												Invalid Email Address
											</mat-error>
										</mat-form-field>
									</div>
									<div class="col-sm-6">
										<mat-form-field class="full-input">
											<input matInput placeholder="Phone Number" maxlength="10"
												formControlName="PhoneNumber">
											<mat-error *ngIf="!f.PhoneNumber.valid && f.PhoneNumber.touched">
												<span *ngIf="(f.PhoneNumber.hasError('pattern') || f.PhoneNumber.hasError('minlength') || f.PhoneNumber.hasError('maxlength')) && (f.PhoneNumber.pristine || f.PhoneNumber.dirty)">
													Should contain only 10-digit numbers
												</span>
												<span *ngIf="(!f.PhoneNumber.hasError('pattern') && !f.PhoneNumber.hasError('minlength') && !f.PhoneNumber.hasError('maxlength')) && (f.PhoneNumber.pristine || f.PhoneNumber.dirty)">
													<strong>Required</strong>
												</span>
											</mat-error>
										</mat-form-field>
									</div>
									<div class="col-sm-6">
										<mat-form-field class="full-input">
											<input matInput placeholder="Customer Account Number" readonly
												formControlName="CustomerAccountNumber">
											<!--<mat-error *ngIf="!f.CustomerAccountNumber.valid && f.CustomerAccountNumber.touched">
												<mat-error *ngIf="(!f.CustomerAccountNumber.hasError('pattern') && !f.CustomerAccountNumber.hasError('minlength') && !f.CustomerAccountNumber.hasError('maxlength'))
													 && (f.CustomerAccountNumber.pristine || f.CustomerAccountNumber.dirty)">
													<strong>Required</strong>
												</mat-error>
											</mat-error>-->
										</mat-form-field>
									</div>
								</div>
								<h4 class="prsnl-ttl">
									Account Information
								</h4>
								<div class="row" [ngClass]="{'forceChangePassword': forceChangePassword}">
									<div class="col-sm-3">
										<div>
											<img class="ban-ht-wrp" id="blah"
												[src]="imageSrc || 'http://placehold.it/180'" alt="banner image" />

										</div>
										<input type='button' class="chng-img-spc" value="Change Image"
											(click)="openUploadImageDialog()">
									</div>
									<div class="col-sm-9">
										<div class="row">
											<div class="col-sm-6">
												<mat-form-field class="full-input">
													<input matInput placeholder="User name" formControlName="UserName"
														readonly>
												</mat-form-field>
											</div>
											<div class="col-sm-6">
												<mat-form-field class="full-input">
													<input type="password" matInput placeholder="Current Password"
														formControlName="CurrentPassword" autocomplete="off"
														autofill="off">
													<mat-error
														*ngIf="f.CurrentPassword.hasError('MatchPassword') && f.CurrentPassword.touched">
														Password is required for change password
													</mat-error>
												</mat-form-field>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<mat-form-field class="full-input">
													<input type="password" matInput placeholder="New Password"
														formControlName="Password">
													<mat-error
														*ngIf="f.Password.touched && !f.Password.hasError('MatchPassword')">
														<strong>Required</strong>
													</mat-error>
													<mat-error
														*ngIf="!f.Password.valid && f.Password.hasError('MatchPassword') && f.Password.touched">
														Current and new password cannot be same
													</mat-error>
												</mat-form-field>
											</div>
											<div class="col-sm-6">
												<mat-form-field class="full-input">
													<input type="password" matInput placeholder="Confirm Password"
														formControlName="ConfirmPassword">
													<mat-error
														*ngIf="f.ConfirmPassword.valid && f.ConfirmPassword.touched && (f.ConfirmPassword.pristine || f.ConfirmPassword.dirty)">
														<strong>Required</strong>
													</mat-error>
													<mat-error
														*ngIf="f.ConfirmPassword.hasError('MatchPassword') && f.ConfirmPassword.touched">
														Password does not match
													</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<!-- SSN Details -->
								<div class="bank-head">
									<h3>
										Payment data & Tax Status
									</h3>
								</div>
								<div class="blue-box">
									Based on your personal information, your tax information needs to be changed.
								</div>
								<div class="col-lg-12 mat-crd-ui dv-cstm-edit">
									<mat-card>
										<mat-card-title>
											Choose which situation applies to you:
										</mat-card-title>
										<mat-card-content>
											<div class="row">
												<div class="col-sm-3">
													<a class="btn btn-primary btn-cstm"
														(click)="Taxable(1,editEndUserProfileForm)">Taxable in the US(no
														corporation)</a>
												</div>
												<div class="col-sm-2">
													<a class="btn btn-primary btn-cstm"
														(click)="Taxable(0,editEndUserProfileForm)">Not Taxable in the
														US</a>
												</div>
												<div class="col-sm-3">
													<a class="btn btn-primary btn-cstm">Corporate Taxable in the US</a>
												</div>
												<div class="col-sm-4">
													<b class="side-hdr">Why do we need this information?</b>
													The Commission you earn at MerchLoop count as income.
													Find out what this mean for you in terms of taxation in our help
													center.
													<a>More Info ></a>
												</div>
											</div>
											<div class="row" *ngIf="edited">
												<div class="col-md-8">
													<p>I am Taxable in the United States and am Registering this account
														as an individual,partnership,soleproprietor,non-profit entity or
														other company type. </p>
													<p>I DoNot have a Fedral ID Number(also Known as FEIN,Employer ID
														Number or EIN).I file my taxes using only my Social Security
														Number(SS#) or Tax Identification Number(TIN) </p>
												</div>
											</div>
											<div class="col-sm-4 pdgn-lft" *ngIf="edited">
												<mat-form-field class="example-full-width">
													<input matInput placeholder="Enter your SS# or TIN"
														formControlName="SSN_No">
													<mat-error *ngIf="f.SSN_No.touched && !f.SSN_No.valid">
														<strong>Required (Must Be AlphaNumeric)</strong>
													</mat-error>
												</mat-form-field>
											</div>
										</mat-card-content>
									</mat-card>
								</div>
								<!-- end -->
								<div class="text-right">
									<button class="mat-btn mt-top-spc" mat-raised-button cdkFocusInitial
										[disabled]="editEndUserProfileForm.invalid">Save</button>
								</div>
							</div>
						</form>
					</mat-step>
					<mat-step [stepControl]="secondFormGroup">
						<ng-template matStepLabel>Address</ng-template>
						<div class="pro-st-adwrp">
							<div class="row mt-crt-spc">
								<!-- Add new address button -->
								<div class="col-sm-4">
									<div class="add-new-adrs">
										<div class="display-table">
											<div class="display-cell" (click)="fn_OpenAddAdressDialog()">
												<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
													xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
													width="55" viewBox="0 0 357 357"
													style="enable-background:new 0 0 357 357;" xml:space="preserve">
													<g>
														<g id="add">
															<path
																d="M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z" />
														</g>
													</g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
													<g></g>
												</svg>
												<p>Add New Address</p>
											</div>
										</div>
									</div>
								</div>
								<!-- DYNAMIC ADDRESS -->
								<div class="col-sm-4" *ngFor="let address of addressList">
									<mat-card class="mat-card-cmn dlv-ads dlv-hr-bd">
										<mat-card-header>
											<mat-card-title>
												<!-- <mat-radio-button [value]="address.AddressId">{{address.AddressType}}</mat-radio-button> -->
												<label class="adr-label">{{address.AddressType}}</label>
											</mat-card-title>
										</mat-card-header>
										<mat-card-content>
											<div class="ads-info">
												<h4>{{address.Name}}</h4>
												<p>{{address.AddressLine}}, <br />
													{{address.Country}}, {{address.State}}, <br />
													{{address.ZipCode}}
												</p>
											</div>
											<!-- <div class="dlvr-dt-ara">
												Deliver Here
											</div> -->
										</mat-card-content>
										<div class="mat-cart-ovl">
											<div class="mat-actn-d">
												<a class="edt-ui"
													(click)="fn_OpenEditAddressDialog(address.AddressId)"><i
														class="material-icons">edit</i> </a>
												<a class="dlt-ui" (click)="fn_deleteAddress(address.AddressId)"><i
														class="material-icons">delete</i> </a>
											</div>
										</div>
									</mat-card>
								</div>
							</div>
						</div>
					</mat-step>
				</mat-horizontal-stepper>
			</div>
		</div>
	</div>
</div>
<style>
	.dv-cstm-edit {
		padding-left: 0;
	}

	.dv-cstm-edit .btn-cstm {
		font-size: 12px;
		padding-left: 4px;
	}

	.dv-cstm-edit .mat-card-content {
		margin-top: 10px;
	}

	.dv-cstm-edit .col-sm-3,
	.dv-cstm-edit .col-sm-2,
	.dv-cstm-edit .col-sm-4 {
		padding-right: 0;
	}

	.bank-head h3 {
		font-size: 20px;
		border-bottom: 1px solid #d6d6d6;
		padding: 15px 0;
	}

	.dv-cstm-edit .mat-card-title {
		font-size: 16px;
		font-weight: 600;
		padding-left: 0;
		border-bottom: none;
		padding-bottom: 0;
	}

	.dv-cstm-edit p {
		font-size: 14px;
		line-height: 25px;
		color: rgba(0, 0, 0, .87);
	}
</style>